// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".podcast-player[data-v-0de7a9a8]{border-top-left-radius:.5rem;overflow:hidden}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Podcast2/Show.vue"],"names":[],"mappings":"AAAA,iCAAgB,4BAAA,CAA6B,eAG7C","sourcesContent":[".podcast-player{border-top-left-radius:.5rem;overflow:hidden}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
